import { Bars3Icon } from "@heroicons/react/24/outline";

import Breadcrumb from "../Breadcrumb";
import UserMenu from "../UserMenu";
import { User } from "../../../services/queries/users/types";
import { Business } from "../../../services/queries/businesses/types";

interface TopBarProps {
  pathname: string;
  user: User | null;
  business: Business | null;
  onOpenMobileNav: () => void;
  onSignOut: () => void;
  showHamburger: boolean;
}

export default function TopBar({
  pathname,
  user,
  business,
  onOpenMobileNav,
  onSignOut,
  showHamburger,
}: TopBarProps) {
  return (
    <header className="sticky top-0 z-20 bg-white border-b border-gray-100 pt-[env(safe-area-inset-top)]">
      <div className="flex items-center justify-between h-16 px-4 md:px-6 gap-3">
        <div className="flex items-center gap-3 min-w-0">
          {showHamburger && (
            <button
              onClick={onOpenMobileNav}
              className="p-2 -ml-2 rounded-md text-gray-600 hover:bg-gray-100 md:hidden"
              aria-label="Open navigation menu"
            >
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          )}
          <Breadcrumb pathname={pathname} />
        </div>

        <UserMenu user={user} business={business} onSignOut={onSignOut} />
      </div>
    </header>
  );
}
